import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { AbstractModalComponent } from "../abstract-modal/abstract-modal.component";
import { BsModalRef } from "ngx-bootstrap/modal";
import { WarningModalService } from "../../services/warning-modal/warning-modal.service";
import { PermissionsService } from 'src/app/services/permissions/permissions.service';

@Component({
  selector: 'app-org-name-modal',
  templateUrl: './org-name-modal.component.pug',
  styleUrls: ['./org-name-modal.component.scss'],
  standalone: false
})
export class OrgNameModalComponent extends AbstractModalComponent implements OnInit {

  @Input() billing_name!: string;
  @ViewChild('orgForm', { static: false }) orgForm: any;
  orgDetails: any;
  showValidationError = false;

  constructor(public _bsModalRef: BsModalRef, public modal: WarningModalService, public permissions: PermissionsService) {
    super(_bsModalRef, modal);
  }

  ngOnInit(): void {
    this.orgDetails = { 'billing_name': this.billing_name };
    ;
  }

  cancel() {
    this.canDeactivate().subscribe(response => {
      if (response) {
        this.markAsPristine();
        this._bsModalRef.hide();
      }
    });
  }

  save() {
    this.orgDetails["billing_name"] = this.orgDetails["billing_name"].trim();
    this.messages = [];
    this.showValidationError = true;
    if (!this.orgForm.valid || this.orgDetails["billing_name"] === "") {
      return;
    }
    this.event.emit(this.orgDetails);
  }

  getForm() {
    return this.orgForm;
  }

}
